export default {
  EXPLORER_BACKEND_URL: process.env.REACT_APP_KSTADIUM_EXPLORER_BACKEND_URL,
  EXPLORER_API_KEY: process.env.REACT_APP_KSTADIUM_EXPLORER_API_KEY,
}
